import { Button } from 'primereact/button';
import './App.css';
import './PricingCard.css';
import { useNavigate } from 'react-router-dom';

function PricingCard(props) {
    const navigate = useNavigate();

    return (
        <div className='pricing-card'>
            <div align='center'>
                <div style={{ fontSize: '1.4em' }}>
                    {props.title}
                </div>
                {
                    props.price &&
                    <div>
                        <div className='mk2-title'>
                            {props.price} €
                        </div>
                        <div>
                            per screen / month, 1 year subscription
                        </div>
                        <Button
                            severity='success'
                            label='Get started'
                            size='small'
                            outlined
                            style={{ marginTop: '2em' }}
                            onClick={
                                () => navigate('/login')
                            }
                        />
                    </div>
                }
                {
                    !props.price &&
                    <div>
                        <div className='mk2-title'>
                            custom
                        </div>
                        <div>
                            contact sales for an offer
                        </div>
                        <Button
                            severity='success'
                            label='Contact sales'
                            size='small'
                            outlined
                            style={{ marginTop: '2em' }}
                        />
                    </div>
                }

            </div>
            <div style={{ marginTop: '1em' }}>
                <hr />
            </div>
            <div style={{ margin: '1em' }}>
                {props.children}
            </div>
        </div>
    );
}

export default PricingCard;